import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    buttons: {
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: 15,

      '& .MuiButtonBase-root': {
        margin: '5px 8px 0px 8px',
      },

      '& .grecaptcha-badge': {
        visibility: 'visible',
      },
    },

    footerDivider: {
      borderTop: `1px solid ${palette.borderGray}`,
      padding: '10px 0px 5px',
    },
    cancelButton: { marginLeft: 100 },
    privacyAndTerms: { marginLeft: 5, fontSize: 12 },
    privacyAndTermsTypo: { fontSize: 12, color: palette.gray },
  });
